<template>
  <div class="mymap" :style="{'height':height + 'px'}">
    <g-map-map ref="mapRef" :center="center" :zoom="zoom" :map-type-id="mapType" class="chartmap"
               @zoom_changed="zoomChange" @center_changed="centerChange" :options="{fullscreenControl:false, streetViewControl: false}">

      <g-map-marker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true"
                    :icon="'/images/plugins/gmap-plugins/' + m.image" @mouseover="hoverPOI(m)" @mouseout="unHoverPOI(m)" @click="clickPOI(m)"/>

      <g-map-polygon ref="editPoly" v-for="(overlay,i) in overlayBorders" :paths="overlay" :editable="edit" @paths_changed="updatePath(i, $event)" v-if="overlayBorders.length>0"
                     :options="{ strokeColor: '#00aac3', strokeWeight: 3, fillColor: '#00aac3', fillOpacity: 0, zIndex: -1  }" :key="'k' + i"/>

      <template v-if="markers.length > 0">
        <g-map-info-window v-for="(m, index) in markerInfos" :position="getInfoWindowPosition(m)" :key="index + m.poiInfo" :closeclick="true" @closeclick="closePOI(m)">
          <span style="color:black" v-html="checkPOIInfo(m.poiInfo)"/>
        </g-map-info-window>
      </template>
    </g-map-map>

    <template v-if="!edit">
      <search-menu :map="map" v-if="showSearchbox" placeholder="Karte durchsuchen ..."/>

      <control-overlay :legendEnabled="showLegend" :kmlEnabled="showKML" :legendEntries="legendEntries" :map="map" v-if="mapLoaded" :queryResult="queryResult"
                       :kmlFileDir="kmlFileDir" :kmlTitle="kmlTitle" @show-kml-error="errorMessage = $event" :embedded="embedded" :setupToken="setupToken"/>

      <side-query-overlay :queryID="queryID" :queryParams="queryParams" :embedded="embedded"/>

      <webentity-overlay v-if="contentEntityName" :webentityName="contentEntityName"/>
    </template>
    <template v-else>
      <textarea style="width:165px;height:70px;position:absolute;top:60px;left:10px;background:white;font-size:10px">{{ overlayBordersdisplay  }}</textarea>
    </template>

    <error-message-overlay :errorMessage="errorMessage"/>
  </div>
</template>

<script>
import axios from 'axios'

import controlOverlay from '../../charts/ControlOverlay'
import searchMenu from '../../charts/SearchMenu'
import sideQueryOverlay from '../../charts/SideQueryOverlay'
import errorMessageOverlay from '../../charts/ErrorMessageOverlay'
import webentityOverlay from '../../charts/WebentityOverlay'
import CSVHelper from '../../../classes/CSVHelper'
import {useQueryStore} from 'src/stores/QueryStore.js'

export default {
  name: 'GoogleMapsMarkers',
  props: ['height', 'chartType', 'queryColumns', 'queryResult', 'setupToken', 'queryID', 'queryParams', 'queryMeta', 'embedded'],
  components: {controlOverlay, searchMenu, sideQueryOverlay, errorMessageOverlay, webentityOverlay},

  data() {
    return {
      center: {lat: 48.30639, lng: 14.28611},
      zoom: 9,
      mapLoaded: false,
      map: null,
      markers: [],
      legendEntries: [],
      showLegend: false,
      showKML: false,
      kmlFileDir: null,
      kmlTitle: null,
      showSearchbox: false,
      zoomSetByStorage: false,
      centerSetByStorage: false,
      mapType: "roadmap",
      errorMessage: null,
      edit: this.$route.query.edit !== undefined ? true : false,
      overlayBorders: [],
      overlayBordersCache: [],
      overlayBordersDisplay: "",
      contentEntityName: null,
      mobile: false
    }
  },

  computed: {
    markerInfos() {
      return this.markers.filter((x) => x.poiShowInfo || x.poiClicked)
    }
  },

  watch: {
    queryResult() {
      this.markers = []
      this.legendEntries = []
      this.init()
    }
  },

  methods: {
    init() {
      console.log("init markers")
      this.errorMessage = null
      this.readOverlay()

      if (this.queryResult.length === 0) {
        this.errorMessage = this.queryMeta.msgOnEmptyresult

      } else {
        try {
          let tempLegends = []
          let tempMarkers = []
          let jsonObject = {
            format: {
              source: "epsg:31285",
              target: "epsg:4326"
            },
            data: []
          }
          for (let idx = 0; idx < this.queryResult.length; idx++) {
            let resItem = this.queryResult[idx]

            if (resItem.poi_pos_x === "0" && resItem.poi_pos_y === "0") {
              console.log("Skip marker with 0,0 coordinates: ", resItem)
              return
            }

            let marker = {
              poiCenter: resItem.poi_center,
              poiSymcode: resItem.poi_symcode,
              poiLegend: resItem.poi_legend,
              poiInfo: resItem.poi_info,
              poiShowInfo: false,
              poiClicked: false
            }
            marker.image = this.getMarkerImage(resItem.poi_symcode)
            tempMarkers.push(marker)
            if (marker.poiCenter === 1 && !this.centerSetByStorage) {
              this.startCenter = marker.position
            }

            jsonObject.data.push([parseFloat(resItem.poi_pos_x) + 450000.00, parseFloat(resItem.poi_pos_y) + 5000000.00])

            tempLegends.push({
              legendColor: 'background-image: url("/images/plugins/gmap-plugins/' + marker.image + '");  background-size: 21px 21px;',
              legendText: resItem.poi_legend
            })
          }

          if (jsonObject.data.length > 0) {
            console.log("Convert coordinates: ", jsonObject)

            axios.post(getHost() + "/servlets/DatumConvert/", "reqJSON=" + JSON.stringify(jsonObject),
              {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
              .then(resp => {
                if (resp && resp.data && resp.data.data) {
                  for (var i = 0; i < resp.data.data.length; i++) {
                    let rowArray = resp.data.data[i]
                    tempMarkers[i].position = {lat: rowArray[0], lng: rowArray[1]}
                  }
                  this.markers = tempMarkers
                } else {
                  console.error("Error: no response from DatumConvert!")
                }
              })
              .catch(error => {
                this.eventBus.globalErrorHandling("Fehler beim Konvertieren der Koordinaten.", error)
                this.errorMessage = this.queryMeta.msgOnError
              })

            this.legendEntries = this.removeDuplicates(tempLegends, "legendText")
          }

        } catch (err) {
          this.eventBus.globalErrorHandling("Fehler beim Erstellen der Karte", err)
          this.errorMessage = this.queryMeta.msgOnError
        }
      }
    },

    updatePath(idx, mvcArray) {
      //console.log("mvcArray:", idx, mvcArray)
      let result = []
      for (let i = 0; i < mvcArray.getLength(); i++) {
        for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
          result.push({"lat": mvcArray.getAt(i).getAt(j).lat(), "lng": mvcArray.getAt(i).getAt(j).lng()})
        }
      }
      this.overlayBordersCache[idx] = result
      this.overlayBordersdisplay = JSON.stringify(this.overlayBordersCache).trim()
      //console.log("overlayBordersCache", this.overlayBordersCache)
    },

    readOverlay() {
      if (this.overlayWebentity) {
        const queryStore = useQueryStore()
        queryStore.webEntityGet({webEntityName: this.overlayWebentity})
          .then((webEntity) => {
            if (webEntity.content) {
              this.overlayBorders = safeParseJSON(webEntity.content)
              this.overlayBordersCache = this.overlayBorders
              this.overlayBordersdisplay = JSON.stringify(this.overlayBorders).trim()
            }
          })
      }
    },

    checkPOIInfo(poiInfo) {
      if (poiInfo) {
        poiInfo = poiInfo.replaceAll("&gt;", ">").replaceAll("&lt;", "<")
      }
      return poiInfo
    },

    setupConfig() {
      let mySetupToken = CSVHelper.getObjectArrayFromCSV(this.setupToken)

      if (mySetupToken.mapType) {
        this.mapType = mySetupToken.mapType
      }
      this.showLegend = mySetupToken.legendActive
      this.showKML = mySetupToken.layerSidebarActive
      this.kmlFileDir = mySetupToken.layerFiledir
      this.kmlTitle = mySetupToken.layerSidebarTitle
      this.showSearchbox = mySetupToken.searchboxActive
      this.overlayWebentity = mySetupToken.overlayWebentity
      this.contentEntityName = mySetupToken.contentEntity
      if (!this.zoomSetByStorage && mySetupToken.zoomLevel) {
        this.zoom = mySetupToken.zoomLevel
      }
      if (!this.centerSetByStorage) {
        if (mySetupToken.latLng) {
          let splitStr = mySetupToken.latLng.split(",")
          if (splitStr.length == 2) {
            this.center = {lat: parseFloat(splitStr[0]), lng: parseFloat(splitStr[1])}
          }
        }
      }
    },

    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },

    getMarkerImage(symcode) {
      let image = null
      switch (parseInt(symcode)) {
        case 1:
          image = 'GoogleMarker_g.png';
          break;
        case 2:
          image = 'GoogleMarker_y.png';
          break;
        case 3:
          image = 'GoogleMarker_r.png';
          break;
        case 13:
          image = 'GoogleMarker_warning.png';
          break;
        case 14:
          image = 'GoogleMarker_noEntry.png';
          break;
        case 20:
          image = 'GoogleMarker_info_g.png';
          break;
        case 21:
          image = 'GoogleMarker_info_y.png';
          break;
        case 22:
          image = 'GoogleMarker_info_o.png';
          break;
        case 23:
          image = 'GoogleMarker_info_r.png';
          break;
        case 24:
          image = 'GoogleMarker_info_p.png';
          break;
        case 25:
          image = 'GoogleMarker_info_b.png';
          break;
        case 30:
          image = 'GoogleMarker_wrench_g.png';
          break;
        case 31:
          image = 'GoogleMarker_wrench_y.png';
          break;
        case 32:
          image = 'GoogleMarker_wrench_o.png';
          break;
        case 33:
          image = 'GoogleMarker_wrench_r.png';
          break;
        case 34:
          image = 'GoogleMarker_wrench_p.png';
          break;
        case 35:
          image = 'GoogleMarker_wrench_b.png';
          break;
      }
      return image;
    },

    getInfoWindowPosition(marker) {
      let latOffset = 0.04
      switch (this.zoom) {
        case 1:
          latOffset = 17;
          break;
        case 2:
          latOffset = 9;
          break;
        case 3:
          latOffset = 4.8;
          break;
        case 4:
          latOffset = 2.5;
          break;
        case 5:
          latOffset = 1.2;
          break;
        case 6:
          latOffset = 0.6;
          break;
        case 7:
          latOffset = 0.3;
          break;
        case 8:
          latOffset = 0.15;
          break;
        case 9:
          latOffset = 0.08;
          break;
        case 11:
          latOffset = 0.02;
          break;
        case 12:
          latOffset = 0.01;
          break;
        case 13:
          latOffset = 0.005;
          break;
        case 14:
          latOffset = 0.0025;
          break;
        case 15:
          latOffset = 0.0011;
          break;
        case 16:
          latOffset = 0.0006;
          break;
        case 17:
          latOffset = 0.0003;
          break;
        case 18:
          latOffset = 0.00018;
          break;
        case 19:
          latOffset = 0.0001;
          break;
        case 20:
          latOffset = 0.00004;
          break;
        case 21:
          latOffset = 0.00002;
          break;
      }
      return {lat: marker.position.lat + latOffset, lng: marker.position.lng}
    },

    zoomChange(zoom) {
      if (zoom) {
        this.zoom = zoom
        localStorage.setItem(this.queryID + "__zoomMarkerPOI", JSON.stringify(zoom));
      }
    },

    centerChange(center) {
      localStorage.setItem(this.queryID + "__centerMarkerPOI", JSON.stringify(center));
    },

    clickPOI(m) {
      this.markers.forEach(x => {
        x.poiShowInfo = false
        x.poiClicked = false
      })
      m.poiClicked = true
    },

    hoverPOI(m) {
      if (!this.mobile) {
        m.poiShowInfo = true
      }
    },

    closePOI(m) {
      m.poiClicked = false
      m.poiShowInfo = false
    },

    unHoverPOI(m) {
      if (!this.mobile) {
        m.poiShowInfo = false
      }
    }
  },

  async mounted() {
    if (this.$q.screen.name == 'xs') {
      this.mobile = true
    }
    let lsCenter = localStorage.getItem(this.queryID + "__centerMarkerPOI");
    let lsZoom = localStorage.getItem(this.queryID + "__zoomMarkerPOI");
    if (lsCenter) {
      this.center = safeParseJSON(lsCenter)
      this.centerSetByStorage = true
    }
    if (lsZoom) {
      this.zoom = safeParseJSON(lsZoom)
      this.zoomSetByStorage = true
    }
    await this.$gmapApiPromiseLazy();
    this.setupConfig()
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map
      this.init()
      this.mapLoaded = true
    })
  }
}

</script>

<style lang="sass">
.chartmap
  height: 100%
</style>
